
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f7ce00","d":"M0 85.331h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#e32737","d":"M0 85.331h512v85.337H0z"}}),_c('path',{attrs:{"fill":"#191f6a","d":"M0 170.657h512v85.337H0z"}}),_c('path',{attrs:{"fill":"#00a04e","d":"M0 341.331h512v85.337H0z"}})])
          )
        }
      }
    